/** DD-3702: a lab and a Denthub Pro clinic asking to work together, either way round. */
export enum ClinicRequestStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    DECLINED = 'DECLINED',
}

export enum ClinicRequestDirection {
    /** The lab asked; the clinic's admins answer. */
    LAB_TO_CLINIC = 'LAB_TO_CLINIC',
    /** The clinic asked; the lab's technician admins answer. */
    CLINIC_TO_LAB = 'CLINIC_TO_LAB',
}

/** What either side may see about the other before they are connected. */
export type ClinicRequestParty = {
    _id: string;
    name?: string | null;
    organizationNumber?: string | null;
    city?: string | null;
};

export type ClinicRequest = {
    _id: string;
    lab: ClinicRequestParty;
    clinic: ClinicRequestParty;
    direction: ClinicRequestDirection;
    status: ClinicRequestStatus;
    message?: string | null;
    requestedByName?: string | null;
    requestedAt: string;
    decidedAt?: string | null;
    /** DD-3707: why the request was declined, when the decliner gave a reason. */
    declineReason?: string | null;
};
